export const WithdrawFromAppeals_uischema = {
  pageTitle: {
    text: "Withdraw From Appeals",
  },
  pageInfo: {
    text: `<em>Please note that submitting this will return the status of your application to Denied. Once an appeal request is withdrawn, no further action can be taken on the application.</em>`,
    coloring: "grey",
  },
  sections: [
    {
      fields: [
        {
          machine_name: "withdrawal_reason",
          widget: "select",
          label: "Withdraw Reason",
          selection: [
            "Foreign Worker Deceased",
            "Multiple Filing Application in Process",
            "Multiple Filing Application pending with the Board of Alien Labor Certification (BALCA)",
            "Foreign Worker Terminated",
            "Employer Error in Application Submission",
            "Job Opportunity No Longer Available",
            "Position Filled by US Worker",
            "Other (Please Describe in Notes Section)",
          ],
          value: "- Select -",
          tooltip: `Please use the dropdown below to select a reason documenting your withdrawal request.`,
          validate: ["required"],
        },
        {
          machine_name: "case_note",
          widget: "text_area",
          label: "Notes (Other):",
          validate: ["required"],
          inputLimit: 500,
          rows: 7,
          isVisible: {
            when: "withdrawal_reason",
            is: "Other (Please Describe in Notes Section)",
          },
        },
      ],
    },
  ],
};
